import {Action, Identity} from './common.js';


const KEY_PAGE = 'PAGE';
const KEY_PAGE_LOAD = 'LOAD';
const KEY_PAGE_UNLOAD = 'UNLOAD';

const KEY_IDENTITY_NEWSLETTER = 'NEWSLETTER_HKEY';
const KEY_TOKEN = 'hkey';


export default class PageAction extends Action {

  init() {
    //PAGE_LOAD ACTION
    this._doLoad();

    //PAGE_CLOSE ACTION
    if (window.addEventListener) {
      window.addEventListener('unload', () => {
        this._doClose();
      }, false);
    }

  }

  get type() {return KEY_PAGE;}

  _doLoad() {
    this._details = {
      action: KEY_PAGE_LOAD
    };

    //check if token from newletter
    let token = this._getParameterByName(KEY_TOKEN) || null;
    if(token !== null) {
      this._identity = new Identity(KEY_IDENTITY_NEWSLETTER,token);
    }

    super.sendAction();
  }

  _doClose() {
    this._details = {
      action: KEY_PAGE_UNLOAD
    };
    super.sendAction();
  }

  _getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

}
